module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/forbid.8be25c1c.svg";